import Pages from "../pages/pages.vue"

export const PagesRoutes = [{
  path: "/contents/pages",
  name: "صفحات",
  component: Pages,
}
];
export default PagesRoutes;
